module.exports = __webpack_public_path__ + "img/Close-128.ea118bcf.png";